import React, { useState, useRef, useEffect } from "react";
import DropdownCustom from "../Utils/DropdownCustom";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import { filterSubmenus } from "../../helpers/component_helpers";

const TopBarInside = () => {
    let {menus, idMenuPai} = useSelector(state => ({
        menus: state.Layout.topbarInside.payload || [],
        idMenuPai: state.Layout.topbarInside.id 
    }))

    const originalMenus = menus || []
    const [openDropdown, setOpenDropdown] = useState(null);
    const itemsRef = useRef(null);

    if (idMenuPai !== null && idMenuPai !== undefined) {
        const idMenuPaiNum = Number(idMenuPai);
        menus = menus.filter(item => Number(item.ID_Menu_Pai) === idMenuPaiNum);
    } else {
        menus = menus.filter(item => !item.ID_Menu_Pai || item.ID_Menu_Pai === 0 || item.ID_Menu_Pai === null)
    }

    const handleToggle = (menuId) => {
        setOpenDropdown(openDropdown === menuId ? null : menuId);
    };

    useEffect(() => {
        const itemsElement = itemsRef.current;
        if (!itemsElement) return;

        const handleWheel = (e) => {
            const isOverDropdown = e.target.closest('.dropdown-menu');
            const isOverSubmenu = e.target.closest('.submenu-custom');
            
            if (isOverDropdown || isOverSubmenu) {
                return;
            }

            if (e.deltaY !== 0) {
                e.preventDefault();
                itemsElement.scrollLeft += e.deltaY;
            }
        };

        itemsElement.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            itemsElement.removeEventListener('wheel', handleWheel);
        };
    }, []);

  return (
    <React.Fragment>
      <div id="page-topbarInsideTopBarInside" className="d-flex align-items-center justify-content-center">
        <div className="navbar-container">
            <div 
                ref={itemsRef}
                className="items"
            >
                {menus && menus.length > 0 ? 
                    <>
                        {menus.map((item, key) => (
                            <div key={`menu-item-${item?.ID_Menu}-${key}`} style={{ position: 'relative', display: 'inline-block' }}>
                                {item.Dropdown === 'S' ?
                                    <DropdownCustom 
                                        key={`dropdown-${item?.ID_Menu}`}
                                        originalDataMenus={originalMenus} 
                                        className={item?.Disponivel == 'N' ? 'disabled' : ''} 
                                        icon={item?.Icone_Transacao} 
                                        items={(() => {
                                            if (item?.childrens?.length) {
                                                return item.childrens.map(child => {
                                                    if (child.ID_Menu != null) {
                                                        const fullItem = originalMenus?.find(m => m.ID_Menu === child.ID_Menu);
                                                        return fullItem || child;
                                                    }
                                                    return child;
                                                });
                                            }
                                            return filterSubmenus(originalMenus, item?.ID_Menu);
                                        })()}
                                        label={item?.Transacao || "Dropdown"}
                                        menuId={item?.ID_Menu}
                                        isOpen={openDropdown === item?.ID_Menu}
                                        onToggle={() => handleToggle(item?.ID_Menu)}
                                    />
                                :  <Link 
                                        key={key} 
                                        to={(item?.URL_Transacao || item?.Codigo_Transacao) ? "/" + (item?.URL_Transacao || item?.Codigo_Transacao) : "#"} 
                                        className={`btn btn-item-topbar-inside ${item?.Disponivel == 'N' ? 'disabled' : ''}`}
                                    >
                                        {item.Icone_Transacao && <i className={item.Icone_Transacao}></i>}
                                        <span className="d-none d-xl-inline-block">{item.Transacao || item.Descricao}</span>
                                    </Link>
                                }
                            </div>
                        ))}
                    </>
                : 
                <Spinner color="primary" size="md">
                    Carregando...
                </Spinner>}
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TopBarInside;